import { getPageFromRouterOrDefault } from '@/utils/urlHelper'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

export const usePagination = (
  initialPage: number
): { page: number; handlePageChange: (newPage: number) => void } => {
  const router = useRouter()
  const [page, setPage] = useState<number>(initialPage)

  useEffect(() => {
    setPage(getPageFromRouterOrDefault(router))
  }, [router.query.page])

  const handlePageChange = (newPage: number) => {
    setPage(newPage)
    router.push(
      { query: { ...router.query, page: newPage.toString() } },
      undefined,
      {
        shallow: true
      }
    )
  }

  return { page, handlePageChange }
}
